<template>
  <div v-if="item.title !== 'מזומן שטרות'" class="checkout-payment__item" :class="activeType" @click="onClick">
    <div class="checkout-payment__item-headline">
      {{ item.title }}
    </div>
    <div class="checkout-payment__item-active">
      <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="3.13523" height="14.9993" rx="1" transform="matrix(0.697214 0.716863 -0.697214 0.716863 13.814 0)"
              fill="white"/>
        <rect width="3.13523" height="7.88965" rx="1"
              transform="matrix(-0.697214 0.716863 -0.697214 -0.716863 7.68677 10.7524)" fill="white"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentItem",
  emits: ['change'],
  props: ['item', 'modelValue', 'isActive'],
  computed: {
    activeType() {
      return {
        active: this.isActive
      }
    }
  },
  methods: {
    onClick(e) {
      if (!this.isActive) {
        this.$emit('change', this.item.code)
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .checkout-payment__item {
    width: 100%;
  }
}
</style>
